<template>
  <div ref="switcher" class="text-size-selector" :class="isopen ? 'is-open':''">
    <span v-if="haslabel">{{ $t("text_size") }}: </span>
    <button class="button text-small" :class="{ 'is-active': fontSize ==='small' }" @click="setTextSize('small')">A</button>
    <button class="button text-medium" :class="{ 'is-active': fontSize ==='medium' }" @click="setTextSize('medium')">A</button>
    <button class="button text-large" :class="{ 'is-active': fontSize ==='large' }" @click="setTextSize('large')">A</button>
    <button class="button text-expander" @click="expand"><span class="icon-text_expander"></span></button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    isopen: {
      type: Boolean,
      default: false
    },
    haslabel: {
      type: Boolean,
      default: false
    },
  },
  components: {},
  data(){
    return{
      htmlEl: null,
      switcher: null,
      hover: false,
      sizes: [
        'small',
        'medium',
        'large'
      ]
    }
  },
  computed: {
    ...mapGetters([
      'fontSize',
    ]),
  },
  methods:{
    ...mapActions([
      'setFontSize',
    ]),
    clearSize: function(){
      for( const size of this.sizes){
        this.htmlEl.classList.remove('text-size-' + size)
      }
    },
    setTextSize: function(size) {
      this.$cookies.set('textSize', size, '30d')
      this.setFontSize({ size: size })
      this.update()
    },
    update: function(){
      this.clearSize()
      this.htmlEl.classList.add('text-size-' + this.fontSize)
      if(!this.isopen){
        this.switcher.classList.remove('is-open')
      }
    },
    expand: function(e){ // eslint-disable-line no-unused-vars
      // console.log(e)
      this.switcher.classList.add('is-open')
    },
  },
  created(){},
  mounted(){
    this.htmlEl= document.documentElement
    this.switcher = this.$refs.switcher

    if(!this.isopen){
      this.switcher.addEventListener('mouseenter', () => this.hover = true)
      this.switcher.addEventListener('mouseleave', () => {
        this.hover = false
        setTimeout(() => {
          if(!this.hover) this.switcher.classList.remove('is-open')
        }, 5000)
      })
    }
  }

}
</script>
<style lang="sass"></style>
